import { render, staticRenderFns } from "./BulkAssistant.vue?vue&type=template&id=6f49252f&scoped=true&"
import script from "./BulkAssistant.vue?vue&type=script&lang=js&"
export * from "./BulkAssistant.vue?vue&type=script&lang=js&"
import style0 from "./BulkAssistant.vue?vue&type=style&index=0&id=6f49252f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49252f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f49252f')) {
      api.createRecord('6f49252f', component.options)
    } else {
      api.reload('6f49252f', component.options)
    }
    module.hot.accept("./BulkAssistant.vue?vue&type=template&id=6f49252f&scoped=true&", function () {
      api.rerender('6f49252f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/BulkAssistant/BulkAssistant.vue"
export default component.exports